import './styles.scss'
import React, { useEffect, createRef } from 'react'
import { I18n } from 'react-redux-i18n'

import { useIntersection } from 'hooks'
import { getStaticImage } from 'utils/statics'

const Tooltip = ({ modalPortal, toggle, coords, onChange, tooltipPosition, setTooltipPosition }) => {
  const tooltipRef = createRef(null)
  const [entry, setNode] = useIntersection({})

  useEffect(() => {
    if (!entry) {
      let newTooltipPosition = ''

      if (tooltipPosition === 'top') newTooltipPosition = 'bottom'
      if (tooltipPosition === 'right') newTooltipPosition = 'left'
      if (tooltipPosition === 'bottom') newTooltipPosition = 'top'
      if (tooltipPosition === 'left') newTooltipPosition = 'right'

      setTooltipPosition(newTooltipPosition)
    }
  }, [entry])

  useEffect(() => {
    if(tooltipRef && tooltipRef.current) {
      setNode(tooltipRef.current)

      const tooltip = tooltipRef.current
      const tooltipCoordinates = tooltip.getBoundingClientRect()

      tooltip.style.top = tooltipPosition === 'top'
        ? `calc(${Math.trunc(coords.bottom)}px - ${Math.trunc(tooltipCoordinates.height)}px - 35px)`
        : ['right', 'left'].includes(tooltipPosition)
          ? `calc(${Math.trunc(coords.bottom)}px - ${Math.trunc(tooltipCoordinates.height / 2)}px - 9px)`
          : `calc(${Math.trunc(coords.bottom)}px + 20px)`

      tooltip.style.left = ['top', 'bottom'].includes(tooltipPosition)
        ? `calc(${Math.trunc(coords.right)}px - ${Math.trunc(tooltipCoordinates.width / 2)}px - 9px)`
        : tooltipPosition === 'right'
          ? `calc(${Math.trunc(coords.right)}px + 21px)`
          : `calc(${Math.trunc(coords.right - tooltipCoordinates.width)}px - 33px)`

      modalPortal.addEventListener('click', toogleModalPortal)
    }

    return () => modalPortal.removeEventListener('click', toogleModalPortal)
  }, [tooltipRef, coords, tooltipPosition])

  const toogleModalPortal = (event) => {
    if (event.target.style.display === 'flex') {
      event.target.style.display = 'none'
      toggle()
    } else {
      event.target.style.display = 'flex'
    }
  }

  return (
    <div ref={tooltipRef} className='sentiment-tooltip__tooltip'>
      <div className='sentiment-tooltip__content'>
        <button
          className='sentiment-tooltip__option'
          onClick={() => {
            onChange('positive')
            toggle()
          }}
        >
          <figure>
            <img alt="positive" src={getStaticImage('/icons/orange-brand/positive.svg')} />
          </figure>
          <span>{I18n.t('dashboard_positive')}</span>
        </button>
        <button
          className='sentiment-tooltip__option'
          onClick={() => {
            onChange('neutral')
            toggle()
          }}
        >
          <figure>
            <img alt="neutral" src={getStaticImage('/icons/orange-brand/neutral.svg')} />
          </figure>
          <span>{I18n.t('dashboard_neutral')}</span>
        </button>
        <button
          className='sentiment-tooltip__option'
          onClick={() => {
            onChange('negative')
            toggle()
          }}
        >
          <figure>
            <img alt="negative" src={getStaticImage('/icons/orange-brand/negative.svg')} />
          </figure>
          <span>{I18n.t('dashboard_negative')}</span>
        </button>
        <button
          className='sentiment-tooltip__option'
          onClick={() => {
            onChange('insult')
            toggle()
          }}
        >
          <figure>
            <img alt="insult" src={getStaticImage('/icons/orange-brand/insult.svg')} />
          </figure>
          <span>{I18n.t('dashboard_insult')}</span>
        </button>
      </div>
      <div
        className='sentiment-tooltip__arrow'
        style={{
          top: ['top', 'right', 'left'].includes(tooltipPosition) ? null : '-10px',
          right: ['top', 'right', 'bottom'].includes(tooltipPosition) ? null : '-10px',
          bottom: ['right', 'bottom', 'left'].includes(tooltipPosition) ? null : '-10px',
          left: ['top', 'bottom', 'left'].includes(tooltipPosition) ? null : '-10px',
          borderTop: `10px solid ${['bottom', 'left'].includes(tooltipPosition) ? '#ffffff' : 'transparent'}`,
          borderRight: `10px solid ${['top', 'left'].includes(tooltipPosition) ? '#ffffff' : 'transparent'}`,
          borderBottom: `10px solid ${['top', 'right'].includes(tooltipPosition) ? '#ffffff' : 'transparent'}`,
          borderLeft: `10px solid ${['right', 'bottom'].includes(tooltipPosition) ? '#ffffff' : 'transparent'}`
        }}
      ></div>
    </div>
  )
}

export default Tooltip
